import React from 'react';
import api from '../../../api';
import {
  IGetDfreeBDeviceAnalyticsTraversalParams,
  IGetDfreeBDeviceAnalyticsTraversalRes,
} from '@/types/api/traversal/getDfreeBDeviceAnalytics';

export const useFetchGasAnalytics = (
  shouldInitFetch: boolean = false, //初回fetchをするかどうか
  nursingHomeId: number | null,
  residentId: number | null = null,
  from: string | null = null,
  to: string | null = null
) => {
  const [gasAnalytics, setGasAnalytics] = React.useState<IGetDfreeBDeviceAnalyticsTraversalRes>();

  const fetchGasAnalytics = async (
    nursingHomeId: number,
    residentId: number,
    from: string | null = null,
    to: string | null = null
  ) => {
    const params: IGetDfreeBDeviceAnalyticsTraversalParams = {
      nursingHomeId,
      residentId,
      from,
      to,
    };

    if (!from) delete params.from;
    if (!to) delete params.to;

    let result = await api.get('/traversal/nursing-homes/:nursingHomeId/residents/:residentId/gas/analytics', {
      params,
    });

    setGasAnalytics(result);
    return result;
  };

  React.useEffect(() => {
    if (!shouldInitFetch || !residentId || !nursingHomeId) return;
    fetchGasAnalytics(nursingHomeId, residentId, from, to);
  }, []);

  return { gasAnalytics, fetchGasAnalytics };
};
